import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import MessageGroup from "../../ListItems/MessageGroup";
import store from "../../../store";
import * as appsyncOperations from "../../../utils/appsyncOperations";
import getDefaultFormattedTime from "../../../utils/getDefaultFormattedTime";

const Response = ({ isOpen, onClose, instanceId }) => {
  const classes = useStyles();
  const [state, setState] = React.useState({ loading: false, messages: [] });

  let timezone;
  if (state.messages.length > 0) {
    const propertyEvent = state.messages[0];
    const property = store.getState().properties.byId[propertyEvent.propertyId];
    if (property) {
      timezone = property.place.timezone;
    }
  }
  const messageGroups = React.useMemo(
    () => getMessageGroups(state.messages, timezone),
    [state.messages]
  );

  React.useEffect(() => {
    if (instanceId) {
      setState({ loading: true, messages: [], error: null });
      appsyncOperations.getPropertyEventsForInstance(instanceId).then(
        (propertyEvents) =>
          setState({ loading: false, messages: propertyEvents }),
        (error) => setState({ loading: false, messages: [], error })
      );
    }
  }, [instanceId]);

  return (
    <Dialog open={isOpen} onClose={onClose} scroll="paper">
      <DialogTitle>Response</DialogTitle>
      <DialogContent>
        {state.loading ? (
          <div className={classes.loadingContainer}>
            <CircularProgress color="primary" />
          </div>
        ) : (
          <div className={classes.scrollableMessages}>
            <div className={classes.messages}>
              {messageGroups.map((messageGroup) => (
                <MessageGroup
                  key={messageGroup.key}
                  userId={messageGroup.userId}
                  messages={messageGroup.messages}
                  date={messageGroup.date}
                />
              ))}
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const getMessageGroups = (propertyEvents, timezone) => {
  const messageGroups = [];
  let currentMessageGroup;
  let currentPropertyEventTimestamp;
  for (const propertyEvent of propertyEvents.reverse()) {
    const propertyEventTimestamp = propertyEvent.createdAt;
    if (currentMessageGroup === undefined) {
      currentMessageGroup = {
        key: propertyEvent.eventId,
        userId: propertyEvent.senderId,
        messages: [],
        date: getDefaultFormattedTime(propertyEventTimestamp, timezone),
      };
    } else if (currentMessageGroup.userId !== propertyEvent.senderId) {
      messageGroups.push(currentMessageGroup);
      currentMessageGroup = {
        key: propertyEvent.eventId,
        userId: propertyEvent.senderId,
        messages: [],
        date:
          currentPropertyEventTimestamp !== undefined &&
          Math.abs(propertyEventTimestamp - currentPropertyEventTimestamp) >
            3600000 /* 1 hour */
            ? getDefaultFormattedTime(propertyEventTimestamp, timezone)
            : undefined,
      };
    } else if (
      currentPropertyEventTimestamp !== undefined &&
      Math.abs(propertyEventTimestamp - currentPropertyEventTimestamp) >
        3600000 /* 1 hour */
    ) {
      messageGroups.push(currentMessageGroup);
      currentMessageGroup = {
        key: propertyEvent.eventId,
        userId: propertyEvent.senderId,
        messages: [],
        date: getDefaultFormattedTime(propertyEventTimestamp, timezone),
      };
    }
    currentPropertyEventTimestamp = propertyEventTimestamp;
    const message = {
      id: propertyEvent.eventId,
      text: propertyEvent.text,
      timestamp: propertyEvent.createdAt,
    };
    currentMessageGroup.messages.push(message);
  }
  // Have to add the last message group that was being created to the array!
  if (currentMessageGroup) {
    messageGroups.push(currentMessageGroup);
  }
  return messageGroups;
};

const useStyles = makeStyles((theme) => ({
  scrollableMessages: {
    display: "flex",
    flex: 1,
    // overflowY: 'auto'
  },
  loadingContainer: {
    minHeight: 64,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
  },
  messages: {
    paddingBottom: 16,
    paddingTop: 16,
  },
}));

export default Response;
